"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Workflow Automation
 * Worklow Automation API We  support the following components<ul> <li><b>Action (or Task)</b> - Predefined units of work that the system can perform. An action could be something like send an email or assign the shipment to this carrier. An action<ul> <li>Will have a name</li> <li>May specify inputs it takes</li> <li>May specify outputs it produces</li> <li>Could throw an Exception</li></ul> <li><b>Junction</b> - Specifies how the different steps are connected to each other (converging, diverging)</li> <li><b>Start</b> - There must be one at least one place to start</li> <li><b>End</b> - Marks the end of a process workflow </li> <li><b>Data objects</b> - these objects will be defined and maintained by the development team. These objects could be things like shipments, companies, users, tenders etc.</li> <li><b>Signals</b> - Workflow steps can listen for an incoming signal for things like triggering the next step, interrupting execution or triggering other flows. </li></ul>
 *
 * The version of the OpenAPI document: 0.1.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowsApi = exports.WorkflowsApiFactory = exports.WorkflowsApiFp = exports.WorkflowsApiAxiosParamCreator = exports.WorkflowTriggeringEventsApi = exports.WorkflowTriggeringEventsApiFactory = exports.WorkflowTriggeringEventsApiFp = exports.WorkflowTriggeringEventsApiAxiosParamCreator = exports.WorkflowExecutionsApi = exports.WorkflowExecutionsApiFactory = exports.WorkflowExecutionsApiFp = exports.WorkflowExecutionsApiAxiosParamCreator = exports.WorkflowExecutionInstancesApi = exports.WorkflowExecutionInstancesApiFactory = exports.WorkflowExecutionInstancesApiFp = exports.WorkflowExecutionInstancesApiAxiosParamCreator = exports.BulkOperationsApi = exports.BulkOperationsApiFactory = exports.BulkOperationsApiFp = exports.BulkOperationsApiAxiosParamCreator = exports.XOrBranchBehavior = exports.WorkflowTriggeringEventPolicyTypeAssociatedWithHandledEventEnum = exports.WorkflowRelatedResourceReferenceAllOfResourceTypeEnum = exports.WorkflowRelatedResourceReferenceResourceTypeEnum = exports.WorkflowExecutionRelatedResourceReferenceAllOfResourceTypeEnum = exports.WorkflowExecutionRelatedResourceReferenceResourceTypeEnum = exports.WorkflowExecutionInstanceStatusEnum = exports.WorkflowExecutionEventWorkflowExecutionEventTypeEnum = exports.TimerTriggerAllOfTriggerTypeEnum = exports.TimerTriggerTriggerTypeEnum = exports.SignalTriggerAllOfSignalTypeEnum = exports.SignalTriggerAllOfTriggerTypeEnum = exports.SignalTriggerSignalTypeEnum = exports.SignalTriggerTriggerTypeEnum = exports.OrBranchBehavior = exports.NoneTriggerAllOfTriggerTypeEnum = exports.NoneTriggerTriggerTypeEnum = exports.ContextVariableDataType = exports.ConditionalTriggerAllOfTriggerTypeEnum = exports.ConditionalTriggerTriggerTypeEnum = exports.ConditionalSplitJunctionType = exports.ConditionalJoinJunctionType = exports.BulkOperationResponseStatusEnum = exports.BulkOperationResponseResourceTypeEnum = exports.BulkOperationResourceStatusStatusEnum = exports.BulkOperationRequestResourceTypeEnum = exports.BulkOperationRelatedResourceReferenceAllOfResourceTypeEnum = exports.BulkOperationRelatedResourceReferenceResourceTypeEnum = exports.ActionRefAllOfActionIdEnum = exports.ActionRefActionIdEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.ActionRefActionIdEnum = {
    ModifyShipmentStopDates: 'MODIFY_SHIPMENT_STOP_DATES',
    InitiateCheckCall: 'INITIATE_CHECK_CALL',
    CreateShipmentFromPurchaseOrder: 'CREATE_SHIPMENT_FROM_PURCHASE_ORDER',
    CreateSpotNegotiations: 'CREATE_SPOT_NEGOTIATIONS',
    PostToLoadboard: 'POST_TO_LOADBOARD',
    SendEmail: 'SEND_EMAIL',
    SimpleLogService: 'SIMPLE_LOG_SERVICE',
    ModifyShipmentStatus: 'MODIFY_SHIPMENT_STATUS',
    Tender: 'TENDER',
    QuoteAndTenderLtl: 'QUOTE_AND_TENDER_LTL'
};
exports.ActionRefAllOfActionIdEnum = {
    ModifyShipmentStopDates: 'MODIFY_SHIPMENT_STOP_DATES',
    InitiateCheckCall: 'INITIATE_CHECK_CALL',
    CreateShipmentFromPurchaseOrder: 'CREATE_SHIPMENT_FROM_PURCHASE_ORDER',
    CreateSpotNegotiations: 'CREATE_SPOT_NEGOTIATIONS',
    PostToLoadboard: 'POST_TO_LOADBOARD',
    SendEmail: 'SEND_EMAIL',
    SimpleLogService: 'SIMPLE_LOG_SERVICE',
    ModifyShipmentStatus: 'MODIFY_SHIPMENT_STATUS',
    Tender: 'TENDER',
    QuoteAndTenderLtl: 'QUOTE_AND_TENDER_LTL'
};
exports.BulkOperationRelatedResourceReferenceResourceTypeEnum = {
    BulkOperation: 'bulk_operation'
};
exports.BulkOperationRelatedResourceReferenceAllOfResourceTypeEnum = {
    BulkOperation: 'bulk_operation'
};
exports.BulkOperationRequestResourceTypeEnum = {
    Shipment: 'shipment'
};
exports.BulkOperationResourceStatusStatusEnum = {
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Error: 'ERROR'
};
exports.BulkOperationResponseResourceTypeEnum = {
    Shipment: 'shipment'
};
exports.BulkOperationResponseStatusEnum = {
    Requested: 'REQUESTED',
    Processing: 'PROCESSING',
    Finished: 'FINISHED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ConditionalJoinJunctionType = {
    ConditionalJoin: 'CONDITIONAL_JOIN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ConditionalSplitJunctionType = {
    ConditionalSplit: 'CONDITIONAL_SPLIT'
};
exports.ConditionalTriggerTriggerTypeEnum = {
    Condition: 'CONDITION'
};
exports.ConditionalTriggerAllOfTriggerTypeEnum = {
    Condition: 'CONDITION'
};
/**
 * Data type of a variable in a workflow execution variable context
 * @export
 * @enum {string}
 */
exports.ContextVariableDataType = {
    String: 'String',
    Date: 'Date',
    PurchaseOrder: 'PurchaseOrder',
    Shipment: 'Shipment',
    Tender: 'Tender',
    PurchaseOrderArray: 'PurchaseOrder[]',
    ShipmentArray: 'Shipment[]',
    TenderArray: 'Tender[]'
};
exports.NoneTriggerTriggerTypeEnum = {
    None: 'NONE'
};
exports.NoneTriggerAllOfTriggerTypeEnum = {
    None: 'NONE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OrBranchBehavior = {
    Or: 'OR'
};
exports.SignalTriggerTriggerTypeEnum = {
    Signal: 'SIGNAL'
};
exports.SignalTriggerSignalTypeEnum = {
    PurchaseOrderCreated: 'PURCHASE_ORDER_CREATED',
    ShipmentCreated: 'SHIPMENT_CREATED'
};
exports.SignalTriggerAllOfTriggerTypeEnum = {
    Signal: 'SIGNAL'
};
exports.SignalTriggerAllOfSignalTypeEnum = {
    PurchaseOrderCreated: 'PURCHASE_ORDER_CREATED',
    ShipmentCreated: 'SHIPMENT_CREATED'
};
exports.TimerTriggerTriggerTypeEnum = {
    Timer: 'TIMER'
};
exports.TimerTriggerAllOfTriggerTypeEnum = {
    Timer: 'TIMER'
};
exports.WorkflowExecutionEventWorkflowExecutionEventTypeEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    UnrecoverableError: 'UNRECOVERABLE_ERROR',
    Start: 'START',
    End: 'END',
    Junction: 'JUNCTION',
    Retry: 'RETRY'
};
exports.WorkflowExecutionInstanceStatusEnum = {
    Running: 'RUNNING',
    Cancelled: 'CANCELLED',
    Success: 'SUCCESS',
    Failed: 'FAILED'
};
exports.WorkflowExecutionRelatedResourceReferenceResourceTypeEnum = {
    WorkflowExecution: 'workflow_execution'
};
exports.WorkflowExecutionRelatedResourceReferenceAllOfResourceTypeEnum = {
    WorkflowExecution: 'workflow_execution'
};
exports.WorkflowRelatedResourceReferenceResourceTypeEnum = {
    Workflow: 'workflow'
};
exports.WorkflowRelatedResourceReferenceAllOfResourceTypeEnum = {
    Workflow: 'workflow'
};
exports.WorkflowTriggeringEventPolicyTypeAssociatedWithHandledEventEnum = {
    OrderConsolidation: 'ORDER_CONSOLIDATION',
    RoutingGuide: 'ROUTING_GUIDE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.XOrBranchBehavior = {
    Or: 'OR'
};
/**
 * BulkOperationsApi - axios parameter creator
 * @export
 */
var BulkOperationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieve a BulkOperation
         * @param {string} bulkOperationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkOperationsBulkOperationIdGet: function (bulkOperationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'bulkOperationId' is not null or undefined
                    (0, common_1.assertParamExists)('bulkOperationsBulkOperationIdGet', 'bulkOperationId', bulkOperationId);
                    localVarPath = "/bulk-operations/{bulkOperationId}"
                        .replace("{".concat("bulkOperationId", "}"), encodeURIComponent(String(bulkOperationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create and initiate a BulkOperation
         * @param {BulkOperationRequest} bulkOperationRequest Request body required to create a BulkOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkOperationsPost: function (bulkOperationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'bulkOperationRequest' is not null or undefined
                    (0, common_1.assertParamExists)('bulkOperationsPost', 'bulkOperationRequest', bulkOperationRequest);
                    localVarPath = "/bulk-operations";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkOperationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.BulkOperationsApiAxiosParamCreator = BulkOperationsApiAxiosParamCreator;
/**
 * BulkOperationsApi - functional programming interface
 * @export
 */
var BulkOperationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BulkOperationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieve a BulkOperation
         * @param {string} bulkOperationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkOperationsBulkOperationIdGet: function (bulkOperationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkOperationsBulkOperationIdGet(bulkOperationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create and initiate a BulkOperation
         * @param {BulkOperationRequest} bulkOperationRequest Request body required to create a BulkOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkOperationsPost: function (bulkOperationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkOperationsPost(bulkOperationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BulkOperationsApiFp = BulkOperationsApiFp;
/**
 * BulkOperationsApi - factory interface
 * @export
 */
var BulkOperationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BulkOperationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieve a BulkOperation
         * @param {string} bulkOperationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkOperationsBulkOperationIdGet: function (bulkOperationId, options) {
            return localVarFp.bulkOperationsBulkOperationIdGet(bulkOperationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create and initiate a BulkOperation
         * @param {BulkOperationRequest} bulkOperationRequest Request body required to create a BulkOperation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkOperationsPost: function (bulkOperationRequest, options) {
            return localVarFp.bulkOperationsPost(bulkOperationRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BulkOperationsApiFactory = BulkOperationsApiFactory;
/**
 * BulkOperationsApi - object-oriented interface
 * @export
 * @class BulkOperationsApi
 * @extends {BaseAPI}
 */
var BulkOperationsApi = /** @class */ (function (_super) {
    __extends(BulkOperationsApi, _super);
    function BulkOperationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieve a BulkOperation
     * @param {string} bulkOperationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkOperationsApi
     */
    BulkOperationsApi.prototype.bulkOperationsBulkOperationIdGet = function (bulkOperationId, options) {
        var _this = this;
        return (0, exports.BulkOperationsApiFp)(this.configuration).bulkOperationsBulkOperationIdGet(bulkOperationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create and initiate a BulkOperation
     * @param {BulkOperationRequest} bulkOperationRequest Request body required to create a BulkOperation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkOperationsApi
     */
    BulkOperationsApi.prototype.bulkOperationsPost = function (bulkOperationRequest, options) {
        var _this = this;
        return (0, exports.BulkOperationsApiFp)(this.configuration).bulkOperationsPost(bulkOperationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BulkOperationsApi;
}(base_1.BaseAPI));
exports.BulkOperationsApi = BulkOperationsApi;
/**
 * WorkflowExecutionInstancesApi - axios parameter creator
 * @export
 */
var WorkflowExecutionInstancesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List workflow executions
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {string} [shipmentId] Filter down to workflow executions related to this shipment ID
         * @param {Array<'workflow'>} [include] Extra fields to include when WorkflowExecution objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionInstancesGet: function (limit, page, shipmentId, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/workflow-execution-instances";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (shipmentId !== undefined) {
                        localVarQueryParameter['shipment_id'] = shipmentId;
                    }
                    if (include) {
                        localVarQueryParameter['include'] = include;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow execution
         * @param {string} workflowExecutionId
         * @param {Array<'workflow'>} [include] Extra fields to include when WorkflowExecution objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionInstancesWorkflowExecutionIdGet: function (workflowExecutionId, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'workflowExecutionId' is not null or undefined
                    (0, common_1.assertParamExists)('workflowExecutionInstancesWorkflowExecutionIdGet', 'workflowExecutionId', workflowExecutionId);
                    localVarPath = "/workflow-execution-instances/{workflowExecutionId}"
                        .replace("{".concat("workflowExecutionId", "}"), encodeURIComponent(String(workflowExecutionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (include) {
                        localVarQueryParameter['include'] = include;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.WorkflowExecutionInstancesApiAxiosParamCreator = WorkflowExecutionInstancesApiAxiosParamCreator;
/**
 * WorkflowExecutionInstancesApi - functional programming interface
 * @export
 */
var WorkflowExecutionInstancesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WorkflowExecutionInstancesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List workflow executions
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {string} [shipmentId] Filter down to workflow executions related to this shipment ID
         * @param {Array<'workflow'>} [include] Extra fields to include when WorkflowExecution objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionInstancesGet: function (limit, page, shipmentId, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowExecutionInstancesGet(limit, page, shipmentId, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow execution
         * @param {string} workflowExecutionId
         * @param {Array<'workflow'>} [include] Extra fields to include when WorkflowExecution objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionInstancesWorkflowExecutionIdGet: function (workflowExecutionId, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowExecutionInstancesWorkflowExecutionIdGet(workflowExecutionId, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WorkflowExecutionInstancesApiFp = WorkflowExecutionInstancesApiFp;
/**
 * WorkflowExecutionInstancesApi - factory interface
 * @export
 */
var WorkflowExecutionInstancesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WorkflowExecutionInstancesApiFp)(configuration);
    return {
        /**
         *
         * @summary List workflow executions
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {string} [shipmentId] Filter down to workflow executions related to this shipment ID
         * @param {Array<'workflow'>} [include] Extra fields to include when WorkflowExecution objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionInstancesGet: function (limit, page, shipmentId, include, options) {
            return localVarFp.workflowExecutionInstancesGet(limit, page, shipmentId, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow execution
         * @param {string} workflowExecutionId
         * @param {Array<'workflow'>} [include] Extra fields to include when WorkflowExecution objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionInstancesWorkflowExecutionIdGet: function (workflowExecutionId, include, options) {
            return localVarFp.workflowExecutionInstancesWorkflowExecutionIdGet(workflowExecutionId, include, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WorkflowExecutionInstancesApiFactory = WorkflowExecutionInstancesApiFactory;
/**
 * WorkflowExecutionInstancesApi - object-oriented interface
 * @export
 * @class WorkflowExecutionInstancesApi
 * @extends {BaseAPI}
 */
var WorkflowExecutionInstancesApi = /** @class */ (function (_super) {
    __extends(WorkflowExecutionInstancesApi, _super);
    function WorkflowExecutionInstancesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List workflow executions
     * @param {number} [limit] Limit list API route results to this number
     * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
     * @param {string} [shipmentId] Filter down to workflow executions related to this shipment ID
     * @param {Array<'workflow'>} [include] Extra fields to include when WorkflowExecution objects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionInstancesApi
     */
    WorkflowExecutionInstancesApi.prototype.workflowExecutionInstancesGet = function (limit, page, shipmentId, include, options) {
        var _this = this;
        return (0, exports.WorkflowExecutionInstancesApiFp)(this.configuration).workflowExecutionInstancesGet(limit, page, shipmentId, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve detailed information about a single workflow execution
     * @param {string} workflowExecutionId
     * @param {Array<'workflow'>} [include] Extra fields to include when WorkflowExecution objects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionInstancesApi
     */
    WorkflowExecutionInstancesApi.prototype.workflowExecutionInstancesWorkflowExecutionIdGet = function (workflowExecutionId, include, options) {
        var _this = this;
        return (0, exports.WorkflowExecutionInstancesApiFp)(this.configuration).workflowExecutionInstancesWorkflowExecutionIdGet(workflowExecutionId, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WorkflowExecutionInstancesApi;
}(base_1.BaseAPI));
exports.WorkflowExecutionInstancesApi = WorkflowExecutionInstancesApi;
/**
 * WorkflowExecutionsApi - axios parameter creator
 * @export
 */
var WorkflowExecutionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List workflow executions
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {Array<string>} [idIn] Filter for workflow executions that have matching IDs.
         * @param {string} [shipmentId] Filter down to workflow executions related to this shipment ID
         * @param {boolean} [includeBulkOperations] If true, return WorkflowExecutions that are operating on sub-resources of BulkOperations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsGet: function (limit, page, idIn, shipmentId, includeBulkOperations, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/workflow-executions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (idIn) {
                        localVarQueryParameter['id.in'] = idIn;
                    }
                    if (shipmentId !== undefined) {
                        localVarQueryParameter['shipment_id'] = shipmentId;
                    }
                    if (includeBulkOperations !== undefined) {
                        localVarQueryParameter['include_bulk_operations'] = includeBulkOperations;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Cancel a running workflow
         * @param {string} workflowExecutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsWorkflowExecutionIdCancelPost: function (workflowExecutionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'workflowExecutionId' is not null or undefined
                    (0, common_1.assertParamExists)('workflowExecutionsWorkflowExecutionIdCancelPost', 'workflowExecutionId', workflowExecutionId);
                    localVarPath = "/workflow-executions/{workflowExecutionId}/cancel"
                        .replace("{".concat("workflowExecutionId", "}"), encodeURIComponent(String(workflowExecutionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow execution
         * @param {string} workflowExecutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsWorkflowExecutionIdGet: function (workflowExecutionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'workflowExecutionId' is not null or undefined
                    (0, common_1.assertParamExists)('workflowExecutionsWorkflowExecutionIdGet', 'workflowExecutionId', workflowExecutionId);
                    localVarPath = "/workflow-executions/{workflowExecutionId}"
                        .replace("{".concat("workflowExecutionId", "}"), encodeURIComponent(String(workflowExecutionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.WorkflowExecutionsApiAxiosParamCreator = WorkflowExecutionsApiAxiosParamCreator;
/**
 * WorkflowExecutionsApi - functional programming interface
 * @export
 */
var WorkflowExecutionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WorkflowExecutionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List workflow executions
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {Array<string>} [idIn] Filter for workflow executions that have matching IDs.
         * @param {string} [shipmentId] Filter down to workflow executions related to this shipment ID
         * @param {boolean} [includeBulkOperations] If true, return WorkflowExecutions that are operating on sub-resources of BulkOperations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsGet: function (limit, page, idIn, shipmentId, includeBulkOperations, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowExecutionsGet(limit, page, idIn, shipmentId, includeBulkOperations, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Cancel a running workflow
         * @param {string} workflowExecutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsWorkflowExecutionIdCancelPost: function (workflowExecutionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowExecutionsWorkflowExecutionIdCancelPost(workflowExecutionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow execution
         * @param {string} workflowExecutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsWorkflowExecutionIdGet: function (workflowExecutionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowExecutionsWorkflowExecutionIdGet(workflowExecutionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WorkflowExecutionsApiFp = WorkflowExecutionsApiFp;
/**
 * WorkflowExecutionsApi - factory interface
 * @export
 */
var WorkflowExecutionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WorkflowExecutionsApiFp)(configuration);
    return {
        /**
         *
         * @summary List workflow executions
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {Array<string>} [idIn] Filter for workflow executions that have matching IDs.
         * @param {string} [shipmentId] Filter down to workflow executions related to this shipment ID
         * @param {boolean} [includeBulkOperations] If true, return WorkflowExecutions that are operating on sub-resources of BulkOperations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsGet: function (limit, page, idIn, shipmentId, includeBulkOperations, options) {
            return localVarFp.workflowExecutionsGet(limit, page, idIn, shipmentId, includeBulkOperations, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Cancel a running workflow
         * @param {string} workflowExecutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsWorkflowExecutionIdCancelPost: function (workflowExecutionId, options) {
            return localVarFp.workflowExecutionsWorkflowExecutionIdCancelPost(workflowExecutionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow execution
         * @param {string} workflowExecutionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowExecutionsWorkflowExecutionIdGet: function (workflowExecutionId, options) {
            return localVarFp.workflowExecutionsWorkflowExecutionIdGet(workflowExecutionId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WorkflowExecutionsApiFactory = WorkflowExecutionsApiFactory;
/**
 * WorkflowExecutionsApi - object-oriented interface
 * @export
 * @class WorkflowExecutionsApi
 * @extends {BaseAPI}
 */
var WorkflowExecutionsApi = /** @class */ (function (_super) {
    __extends(WorkflowExecutionsApi, _super);
    function WorkflowExecutionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List workflow executions
     * @param {number} [limit] Limit list API route results to this number
     * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
     * @param {Array<string>} [idIn] Filter for workflow executions that have matching IDs.
     * @param {string} [shipmentId] Filter down to workflow executions related to this shipment ID
     * @param {boolean} [includeBulkOperations] If true, return WorkflowExecutions that are operating on sub-resources of BulkOperations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionsApi
     */
    WorkflowExecutionsApi.prototype.workflowExecutionsGet = function (limit, page, idIn, shipmentId, includeBulkOperations, options) {
        var _this = this;
        return (0, exports.WorkflowExecutionsApiFp)(this.configuration).workflowExecutionsGet(limit, page, idIn, shipmentId, includeBulkOperations, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Cancel a running workflow
     * @param {string} workflowExecutionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionsApi
     */
    WorkflowExecutionsApi.prototype.workflowExecutionsWorkflowExecutionIdCancelPost = function (workflowExecutionId, options) {
        var _this = this;
        return (0, exports.WorkflowExecutionsApiFp)(this.configuration).workflowExecutionsWorkflowExecutionIdCancelPost(workflowExecutionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve detailed information about a single workflow execution
     * @param {string} workflowExecutionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionsApi
     */
    WorkflowExecutionsApi.prototype.workflowExecutionsWorkflowExecutionIdGet = function (workflowExecutionId, options) {
        var _this = this;
        return (0, exports.WorkflowExecutionsApiFp)(this.configuration).workflowExecutionsWorkflowExecutionIdGet(workflowExecutionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WorkflowExecutionsApi;
}(base_1.BaseAPI));
exports.WorkflowExecutionsApi = WorkflowExecutionsApi;
/**
 * WorkflowTriggeringEventsApi - axios parameter creator
 * @export
 */
var WorkflowTriggeringEventsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List of workflow triggering events
         * @param {number} [limit] Limit list API route results to this number
         * @param {string} [sort] Comma separated list of properties to sort by. Prepend \&#39;-\&#39; to property name for descending
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {Array<string>} [workflowIds] Filter workflow triggering event instances as long as at least one workflow Id matches
         * @param {Array<string>} [eventNames] Filter workflow triggering event instances matching any one of these event names
         * @param {string} [triggeringResourceType] Filter workflow triggering event instances matching this resource type
         * @param {Array<string>} [triggeringResourceIds] Filter workflow triggering event instances matching any one of these resource ids
         * @param {'ORDER_CONSOLIDATION' | 'ROUTING_GUIDE'} [policyTypeAssociatedWithHandledEvent] The type of policy associated with this workflow execution event.
         * @param {Array<'matched_workflows'>} [include] Extra fields to include when rendering WorkflowTriggeringEvent objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowTriggeringEventsGet: function (limit, sort, page, workflowIds, eventNames, triggeringResourceType, triggeringResourceIds, policyTypeAssociatedWithHandledEvent, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/workflow-triggering-events";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (workflowIds) {
                        localVarQueryParameter['workflow_ids'] = workflowIds;
                    }
                    if (eventNames) {
                        localVarQueryParameter['event_names'] = eventNames;
                    }
                    if (triggeringResourceType !== undefined) {
                        localVarQueryParameter['triggering_resource_type'] = triggeringResourceType;
                    }
                    if (triggeringResourceIds) {
                        localVarQueryParameter['triggering_resource_ids'] = triggeringResourceIds;
                    }
                    if (policyTypeAssociatedWithHandledEvent !== undefined) {
                        localVarQueryParameter['policy_type_associated_with_handled_event'] = policyTypeAssociatedWithHandledEvent;
                    }
                    if (include) {
                        localVarQueryParameter['include'] = include;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow triggering event object
         * @param {string} workflowTriggeringEventId
         * @param {Array<'matched_workflows'>} [include] Extra fields to include when rendering WorkflowTriggeringEvent objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowTriggeringEventsWorkflowTriggeringEventIdGet: function (workflowTriggeringEventId, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'workflowTriggeringEventId' is not null or undefined
                    (0, common_1.assertParamExists)('workflowTriggeringEventsWorkflowTriggeringEventIdGet', 'workflowTriggeringEventId', workflowTriggeringEventId);
                    localVarPath = "/workflow-triggering-events/{workflowTriggeringEventId}"
                        .replace("{".concat("workflowTriggeringEventId", "}"), encodeURIComponent(String(workflowTriggeringEventId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (include) {
                        localVarQueryParameter['include'] = include;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.WorkflowTriggeringEventsApiAxiosParamCreator = WorkflowTriggeringEventsApiAxiosParamCreator;
/**
 * WorkflowTriggeringEventsApi - functional programming interface
 * @export
 */
var WorkflowTriggeringEventsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WorkflowTriggeringEventsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List of workflow triggering events
         * @param {number} [limit] Limit list API route results to this number
         * @param {string} [sort] Comma separated list of properties to sort by. Prepend \&#39;-\&#39; to property name for descending
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {Array<string>} [workflowIds] Filter workflow triggering event instances as long as at least one workflow Id matches
         * @param {Array<string>} [eventNames] Filter workflow triggering event instances matching any one of these event names
         * @param {string} [triggeringResourceType] Filter workflow triggering event instances matching this resource type
         * @param {Array<string>} [triggeringResourceIds] Filter workflow triggering event instances matching any one of these resource ids
         * @param {'ORDER_CONSOLIDATION' | 'ROUTING_GUIDE'} [policyTypeAssociatedWithHandledEvent] The type of policy associated with this workflow execution event.
         * @param {Array<'matched_workflows'>} [include] Extra fields to include when rendering WorkflowTriggeringEvent objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowTriggeringEventsGet: function (limit, sort, page, workflowIds, eventNames, triggeringResourceType, triggeringResourceIds, policyTypeAssociatedWithHandledEvent, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowTriggeringEventsGet(limit, sort, page, workflowIds, eventNames, triggeringResourceType, triggeringResourceIds, policyTypeAssociatedWithHandledEvent, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow triggering event object
         * @param {string} workflowTriggeringEventId
         * @param {Array<'matched_workflows'>} [include] Extra fields to include when rendering WorkflowTriggeringEvent objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowTriggeringEventsWorkflowTriggeringEventIdGet: function (workflowTriggeringEventId, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowTriggeringEventsWorkflowTriggeringEventIdGet(workflowTriggeringEventId, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WorkflowTriggeringEventsApiFp = WorkflowTriggeringEventsApiFp;
/**
 * WorkflowTriggeringEventsApi - factory interface
 * @export
 */
var WorkflowTriggeringEventsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WorkflowTriggeringEventsApiFp)(configuration);
    return {
        /**
         *
         * @summary List of workflow triggering events
         * @param {number} [limit] Limit list API route results to this number
         * @param {string} [sort] Comma separated list of properties to sort by. Prepend \&#39;-\&#39; to property name for descending
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {Array<string>} [workflowIds] Filter workflow triggering event instances as long as at least one workflow Id matches
         * @param {Array<string>} [eventNames] Filter workflow triggering event instances matching any one of these event names
         * @param {string} [triggeringResourceType] Filter workflow triggering event instances matching this resource type
         * @param {Array<string>} [triggeringResourceIds] Filter workflow triggering event instances matching any one of these resource ids
         * @param {'ORDER_CONSOLIDATION' | 'ROUTING_GUIDE'} [policyTypeAssociatedWithHandledEvent] The type of policy associated with this workflow execution event.
         * @param {Array<'matched_workflows'>} [include] Extra fields to include when rendering WorkflowTriggeringEvent objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowTriggeringEventsGet: function (limit, sort, page, workflowIds, eventNames, triggeringResourceType, triggeringResourceIds, policyTypeAssociatedWithHandledEvent, include, options) {
            return localVarFp.workflowTriggeringEventsGet(limit, sort, page, workflowIds, eventNames, triggeringResourceType, triggeringResourceIds, policyTypeAssociatedWithHandledEvent, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve detailed information about a single workflow triggering event object
         * @param {string} workflowTriggeringEventId
         * @param {Array<'matched_workflows'>} [include] Extra fields to include when rendering WorkflowTriggeringEvent objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowTriggeringEventsWorkflowTriggeringEventIdGet: function (workflowTriggeringEventId, include, options) {
            return localVarFp.workflowTriggeringEventsWorkflowTriggeringEventIdGet(workflowTriggeringEventId, include, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WorkflowTriggeringEventsApiFactory = WorkflowTriggeringEventsApiFactory;
/**
 * WorkflowTriggeringEventsApi - object-oriented interface
 * @export
 * @class WorkflowTriggeringEventsApi
 * @extends {BaseAPI}
 */
var WorkflowTriggeringEventsApi = /** @class */ (function (_super) {
    __extends(WorkflowTriggeringEventsApi, _super);
    function WorkflowTriggeringEventsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List of workflow triggering events
     * @param {number} [limit] Limit list API route results to this number
     * @param {string} [sort] Comma separated list of properties to sort by. Prepend \&#39;-\&#39; to property name for descending
     * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
     * @param {Array<string>} [workflowIds] Filter workflow triggering event instances as long as at least one workflow Id matches
     * @param {Array<string>} [eventNames] Filter workflow triggering event instances matching any one of these event names
     * @param {string} [triggeringResourceType] Filter workflow triggering event instances matching this resource type
     * @param {Array<string>} [triggeringResourceIds] Filter workflow triggering event instances matching any one of these resource ids
     * @param {'ORDER_CONSOLIDATION' | 'ROUTING_GUIDE'} [policyTypeAssociatedWithHandledEvent] The type of policy associated with this workflow execution event.
     * @param {Array<'matched_workflows'>} [include] Extra fields to include when rendering WorkflowTriggeringEvent objects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTriggeringEventsApi
     */
    WorkflowTriggeringEventsApi.prototype.workflowTriggeringEventsGet = function (limit, sort, page, workflowIds, eventNames, triggeringResourceType, triggeringResourceIds, policyTypeAssociatedWithHandledEvent, include, options) {
        var _this = this;
        return (0, exports.WorkflowTriggeringEventsApiFp)(this.configuration).workflowTriggeringEventsGet(limit, sort, page, workflowIds, eventNames, triggeringResourceType, triggeringResourceIds, policyTypeAssociatedWithHandledEvent, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve detailed information about a single workflow triggering event object
     * @param {string} workflowTriggeringEventId
     * @param {Array<'matched_workflows'>} [include] Extra fields to include when rendering WorkflowTriggeringEvent objects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowTriggeringEventsApi
     */
    WorkflowTriggeringEventsApi.prototype.workflowTriggeringEventsWorkflowTriggeringEventIdGet = function (workflowTriggeringEventId, include, options) {
        var _this = this;
        return (0, exports.WorkflowTriggeringEventsApiFp)(this.configuration).workflowTriggeringEventsWorkflowTriggeringEventIdGet(workflowTriggeringEventId, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WorkflowTriggeringEventsApi;
}(base_1.BaseAPI));
exports.WorkflowTriggeringEventsApi = WorkflowTriggeringEventsApi;
/**
 * WorkflowsApi - axios parameter creator
 * @export
 */
var WorkflowsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List all workflows
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {boolean} [dataIntegrityErrorsIsnull] Filter workflows by whether or not their data integrity errors is null
         * @param {Array<string>} [idIn] Filter for workflows that have matching IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsGet: function (limit, page, dataIntegrityErrorsIsnull, idIn, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/workflows";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (dataIntegrityErrorsIsnull !== undefined) {
                        localVarQueryParameter['data_integrity_errors.isnull'] = dataIntegrityErrorsIsnull;
                    }
                    if (idIn) {
                        localVarQueryParameter['id.in'] = idIn;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create a new workflow
         * @param {Workflow} workflow Workflow create/update object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsPost: function (workflow, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'workflow' is not null or undefined
                    (0, common_1.assertParamExists)('workflowsPost', 'workflow', workflow);
                    localVarPath = "/workflows";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workflow, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a single workflow
         * @param {string} workflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdDelete: function (workflowId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'workflowId' is not null or undefined
                    (0, common_1.assertParamExists)('workflowsWorkflowIdDelete', 'workflowId', workflowId);
                    localVarPath = "/workflows/{workflowId}"
                        .replace("{".concat("workflowId", "}"), encodeURIComponent(String(workflowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieve a single workflow
         * @param {string} workflowId
         * @param {number} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdGet: function (workflowId, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'workflowId' is not null or undefined
                    (0, common_1.assertParamExists)('workflowsWorkflowIdGet', 'workflowId', workflowId);
                    localVarPath = "/workflows/{workflowId}"
                        .replace("{".concat("workflowId", "}"), encodeURIComponent(String(workflowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (version !== undefined) {
                        localVarQueryParameter['version'] = version;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a single workflow
         * @param {string} workflowId
         * @param {Workflow} workflow Workflow create/update object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdPut: function (workflowId, workflow, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'workflowId' is not null or undefined
                    (0, common_1.assertParamExists)('workflowsWorkflowIdPut', 'workflowId', workflowId);
                    // verify required parameter 'workflow' is not null or undefined
                    (0, common_1.assertParamExists)('workflowsWorkflowIdPut', 'workflow', workflow);
                    localVarPath = "/workflows/{workflowId}"
                        .replace("{".concat("workflowId", "}"), encodeURIComponent(String(workflowId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workflow, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.WorkflowsApiAxiosParamCreator = WorkflowsApiAxiosParamCreator;
/**
 * WorkflowsApi - functional programming interface
 * @export
 */
var WorkflowsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.WorkflowsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List all workflows
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {boolean} [dataIntegrityErrorsIsnull] Filter workflows by whether or not their data integrity errors is null
         * @param {Array<string>} [idIn] Filter for workflows that have matching IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsGet: function (limit, page, dataIntegrityErrorsIsnull, idIn, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowsGet(limit, page, dataIntegrityErrorsIsnull, idIn, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new workflow
         * @param {Workflow} workflow Workflow create/update object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsPost: function (workflow, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowsPost(workflow, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a single workflow
         * @param {string} workflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdDelete: function (workflowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowsWorkflowIdDelete(workflowId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a single workflow
         * @param {string} workflowId
         * @param {number} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdGet: function (workflowId, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowsWorkflowIdGet(workflowId, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a single workflow
         * @param {string} workflowId
         * @param {Workflow} workflow Workflow create/update object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdPut: function (workflowId, workflow, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workflowsWorkflowIdPut(workflowId, workflow, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.WorkflowsApiFp = WorkflowsApiFp;
/**
 * WorkflowsApi - factory interface
 * @export
 */
var WorkflowsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.WorkflowsApiFp)(configuration);
    return {
        /**
         *
         * @summary List all workflows
         * @param {number} [limit] Limit list API route results to this number
         * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
         * @param {boolean} [dataIntegrityErrorsIsnull] Filter workflows by whether or not their data integrity errors is null
         * @param {Array<string>} [idIn] Filter for workflows that have matching IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsGet: function (limit, page, dataIntegrityErrorsIsnull, idIn, options) {
            return localVarFp.workflowsGet(limit, page, dataIntegrityErrorsIsnull, idIn, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new workflow
         * @param {Workflow} workflow Workflow create/update object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsPost: function (workflow, options) {
            return localVarFp.workflowsPost(workflow, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a single workflow
         * @param {string} workflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdDelete: function (workflowId, options) {
            return localVarFp.workflowsWorkflowIdDelete(workflowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a single workflow
         * @param {string} workflowId
         * @param {number} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdGet: function (workflowId, version, options) {
            return localVarFp.workflowsWorkflowIdGet(workflowId, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a single workflow
         * @param {string} workflowId
         * @param {Workflow} workflow Workflow create/update object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowsWorkflowIdPut: function (workflowId, workflow, options) {
            return localVarFp.workflowsWorkflowIdPut(workflowId, workflow, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.WorkflowsApiFactory = WorkflowsApiFactory;
/**
 * WorkflowsApi - object-oriented interface
 * @export
 * @class WorkflowsApi
 * @extends {BaseAPI}
 */
var WorkflowsApi = /** @class */ (function (_super) {
    __extends(WorkflowsApi, _super);
    function WorkflowsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List all workflows
     * @param {number} [limit] Limit list API route results to this number
     * @param {number} [page] Which page of a paginated list route to fetch, starting from 1
     * @param {boolean} [dataIntegrityErrorsIsnull] Filter workflows by whether or not their data integrity errors is null
     * @param {Array<string>} [idIn] Filter for workflows that have matching IDs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    WorkflowsApi.prototype.workflowsGet = function (limit, page, dataIntegrityErrorsIsnull, idIn, options) {
        var _this = this;
        return (0, exports.WorkflowsApiFp)(this.configuration).workflowsGet(limit, page, dataIntegrityErrorsIsnull, idIn, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new workflow
     * @param {Workflow} workflow Workflow create/update object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    WorkflowsApi.prototype.workflowsPost = function (workflow, options) {
        var _this = this;
        return (0, exports.WorkflowsApiFp)(this.configuration).workflowsPost(workflow, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a single workflow
     * @param {string} workflowId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    WorkflowsApi.prototype.workflowsWorkflowIdDelete = function (workflowId, options) {
        var _this = this;
        return (0, exports.WorkflowsApiFp)(this.configuration).workflowsWorkflowIdDelete(workflowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a single workflow
     * @param {string} workflowId
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    WorkflowsApi.prototype.workflowsWorkflowIdGet = function (workflowId, version, options) {
        var _this = this;
        return (0, exports.WorkflowsApiFp)(this.configuration).workflowsWorkflowIdGet(workflowId, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a single workflow
     * @param {string} workflowId
     * @param {Workflow} workflow Workflow create/update object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowsApi
     */
    WorkflowsApi.prototype.workflowsWorkflowIdPut = function (workflowId, workflow, options) {
        var _this = this;
        return (0, exports.WorkflowsApiFp)(this.configuration).workflowsWorkflowIdPut(workflowId, workflow, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WorkflowsApi;
}(base_1.BaseAPI));
exports.WorkflowsApi = WorkflowsApi;
